import React, { useState, useEffect } from 'react';
import { ShoppingCartIcon } from '@heroicons/react/24/outline';
import { getCartItemCount, subscribeToCartState } from '../utils/cartManager';

interface CartIconProps {
  onClick: () => void;
  className?: string;
}

const CartIcon: React.FC<CartIconProps> = ({ onClick, className = '' }) => {
  const [itemCount, setItemCount] = useState(getCartItemCount());

  // 监听购物车数量变化
  useEffect(() => {
    const updateCartCount = () => {
      setItemCount(getCartItemCount());
    };

    // 订阅购物车状态变化
    const unsubscribe = subscribeToCartState(updateCartCount);

    return unsubscribe;
  }, []);
  return (
    <button 
      onClick={onClick}
      className={`relative p-2 text-gray-700 hover:text-blue-600 transition-colors ${className}`}
    >
      <div className="w-8 h-8 border-2 border-gray-300 rounded-full flex items-center justify-center">
        <ShoppingCartIcon className="h-5 w-5" />
      </div>
      {itemCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
          {itemCount}
        </span>
      )}
    </button>
  );
};

export default CartIcon; 